<!-- 文件中文名: 购物车 -->
<template>
  <div class="ShoppingCart app-container">
    <div v-loading="doLoading">
      <div v-show="purchaseInfo && this.shoppingList.length > 0" style="padding: 10px">
        <div class="purchase-info">
          <p>
            <i class="el-icon-warning" />
            <!--存在订单类型不同的商品,请查看-->
            {{ $t('hint.1') }}
          </p>
          <p :class="{ 'p-black': btnBlack }" class="p-color" @click="clickPBlack" @mouseenter="btnBlack = true"
            @mouseleave="btnBlack = false">
            X
          </p>
        </div>
      </div>
      <!--购物车-->
      <h2 style="text-align: left">{{ $t('label.shopping.cart') }}</h2>
      <div v-if="this.shoppingList.length > 0">
        <el-form label-width="auto" style="text-align: left">
          <!--经销商编号-->
          <el-form-item v-show="!MemberRegisterData" :label="$t('miMember.memberNo')">
            <el-input @input="value => inputMemberNo = value.toUpperCase()" v-model="inputMemberNo" style="width: 30%"
              class="AppStyle" @blur="getInputMemberNoMessages" />
            &nbsp; <span style="color: red">{{ inputMemberNo2 }}</span>
            <span style="color: green; font-weight: 700">&nbsp;&nbsp;{{ this.$t(this.inputManager) }}</span>
          </el-form-item>
          <!--订单类型-->
          <el-form-item :label="$t('pd.orderType')">
            <el-radio-group v-model="orderType" @change="setOrderType">
              <el-radio :label="17" class="shopping-btn" v-show="sg">
                <!--新注册首购单-->
                <span style="font-size: 20px">{{ $t('NewRegisteredFirstOrder_es_ES') }}</span>
              </el-radio>
              <el-radio :label="18" class="shopping-btn" v-show="sj">
                <!--升级单-->
                <span style="font-size: 20px">{{ $t('miMemberUpgradeNote.updateRemark') }}</span>
              </el-radio>
              <el-radio :label="19" class="shopping-btn" v-show="cx">
                <!--重消单-->
                <span style="font-size: 20px">{{ $t('poOrder.uprec.order') }}</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-table :data="this.shoppingList" :row-class-name="tableRowClassName" class="el-table-border GoodsList"
          style="width: 100%">
          <el-table-column align="center">
            <template slot-scope="scope">
              <el-button :title="$t('button.delete')" icon="el-icon-delete" plain size="small" type="danger"
                @click="clickDelete(scope.row.goodsCode)" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('image')" align="center">
            <template slot-scope="{ row }">
              <el-image :src="row.imgsrc" fit="contain"
                style="width: 100%; height: 100%; border: 0.5px #eeeeee solid"></el-image>
            </template>
          </el-table-column>
          <el-table-column :label="$t('sr.productName')" align="center" prop="goodsName">
            <template slot-scope="{ row }">
              {{ $t(row.goodsName) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('Product.Code')" align="center" prop="goodsCode" />
          <el-table-column :label="$t('biBarCode.quantity')" align="center" width="140">
            <template slot-scope="{ row }">
              <el-input-number v-model.number="row.quantity" :min="1" size="small"
                @change="getTotalPrice(row.quantity)" />
            </template>
          </el-table-column>
          <!--价格-->
          <el-table-column :label="$t('pd.price')" align="right">
            <template slot-scope="{ row }">
              <p v-show="orderType === 17 || orderType === 18">
                {{ row.standardPriceB === 0 ? '--' : row.standardPriceB }}{{ $symbol() }}
              </p>
              <p v-show="orderType === 17 || orderType === 18">
                ({{ row.standardPrice }}W$)
              </p>
              <p v-show="orderType === 19" style="font-size: 24px;">
                {{ row.proPriceB === 0 ? '--' : row.proPriceB }}{{ $symbol() }}
              </p>
              <p v-show="orderType === 19">
                ({{ row.proPrice }}W$)
              </p>
            </template>
          </el-table-column>
          <!--总价格-->
          <el-table-column :label="$t('TotalPrice')" align="right">
            <template slot-scope="{ row }">
              <p v-show="orderType === 17 || orderType === 18">
                {{ getHighPrecisionMul(row.standardPriceB, row.quantity) }}{{ $symbol() }}
              </p>
              <p v-show="orderType === 17 || orderType === 18">
                ({{ getHighPrecisionMul(row.standardPrice, row.quantity) }}W$)
              </p>
              <p v-show="orderType === 19" style="font-size: 24px">
                {{ getHighPrecisionMul(row.proPriceB, row.quantity) }}{{ $symbol() }}
              </p>
              <p v-show="orderType === 19">
                ({{ getHighPrecisionMul(row.proPrice, row.quantity) }}W$)
              </p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('P.V')" align="right">
            <template slot-scope="{ row }">
              <p v-show="orderType === 17 || orderType === 18"> {{ row.standardPv === 0 ? '--' : row.standardPv }}</p>
              <p v-show="orderType === 19"> {{ row.proPv === 0 ? '--' : row.proPv }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('company.me.totalPV')" align="right">
            <template slot-scope="{ row }">
              <p v-show="orderType === 17 || orderType === 18"> {{ getHighPrecisionMul(row.standardPv, row.quantity) }}
              </p>
              <p v-show="orderType === 19"> {{ getHighPrecisionMul(row.proPv, row.quantity) }}</p>
            </template>
          </el-table-column>
          <!--积分-->
          <el-table-column v-if="orderType === 19" :label="$t('busi.direct.sale_points_es_ES')" align="right"
            prop="proF000">
            <template slot-scope="{row}">
              {{ row.proF000 === 0 ? '--' : row.proF000 }}
            </template>
          </el-table-column>
          <!--总积分-->
          <el-table-column v-if="orderType === 19" :label="$t('miagent.fv.total')" align="right">
            <template slot-scope="{ row }">
              <p v-show="orderType === 19">
                {{ getHighPrecisionMul(row.proF000, row.quantity) }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="purchase-info">
          <div style="font-size: 18px;white-space: pre-wrap;" v-show="ifGoods">
            <span>{{ goodsCode }}</span>
            <span>{{ $t('goods.stock.NoSpot') + '!' }} </span>
          </div>
        </div>
        <div style="display: flex;justify-content: end;padding: 10px;">
          <table class="TotalPrice-Table">
            <tbody>
              <tr>
                <td v-if="orderType !== 19" style="border-right: 1px solid #dddddd; padding: 5px">
                  <!--级别-->
                  <strong>{{ $t('commond.levelType') }}</strong>
                </td>
                <td v-if="(!MemberRegisterData || totalFcSG) && orderType !== 19"
                  style="border-right: 1px solid #dddddd; padding: 5px">
                  <el-select v-model="selectlevel" @change="setSjLevel">
                    <el-option v-for="item in levelInfoListShow" :key="item.id" :label="item.totalFc"
                      :value="item.selectlevel" :disabled="item.disabled" />
                  </el-select>
                </td>
                <td style="border-right: 1px solid #dddddd; padding: 5px">
                  <strong>{{ $t('TotalPrice') + (':') }}</strong>
                </td>
                <td style="border-right: 1px solid #dddddd;padding: 5px">
                  <p v-show="orderType === 17 || orderType === 18">{{ TotalPrice7 }}{{ $symbol() }}</p>
                  <p v-show="orderType === 19">{{ TotalPrice6 }}{{ $symbol() }}</p>
                </td>
                <td style="border-right: 1px solid #dddddd;padding: 5px">
                  <p v-show="orderType === 17 || orderType === 18">
                    {{ TotalPrice5 >= 999999 ? '&#45;&#45;' : TotalPrice5 }}W$
                  </p>
                  <p v-show="orderType === 19">{{ TotalPrice1 >= 999999 ? '&#45;&#45;' : TotalPrice1 }}W$</p>
                </td>
                <td style="border-right: 1px solid #dddddd; padding: 5px">
                  <strong>{{ $t('company.me.totalPV') + (':') }}</strong>
                </td>
                <td style="border-right: 1px solid #dddddd; padding: 5px">
                  <p v-show="orderType === 17 || orderType === 18">{{ TotalPrice2 }}</p>
                  <p v-show="orderType === 19">{{ TotalPrice3 }}</p>
                </td>
                <td v-show="orderType === 19" style="border-right: 1px solid #dddddd; padding: 5px">
                  <strong>{{ $t('miagent.fv.total') + (':') }}</strong>
                </td>
                <td v-show="orderType === 19" style="border-right: 1px solid #dddddd; padding: 5px">
                  <p>{{ TotalPrice4 === 0 ? '--' : TotalPrice4 }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 防止塌陷 -->
        <div style="clear: both"></div>
        <div style="display: flex; justify-content: space-between">
          <!-- 继续购买Btn   !17 -->
          <el-button :class="{ 'btn-color-green': ContinueColor }" class="btn-continue" @click="clickContinue"
            @mouseenter.native="ContinueColor = true" @mouseleave.native="ContinueColor = false">{{
              $t('btn.continue.buy') }}
          </el-button>
          <!--          下单-->
          <el-button :loading="doLoading" :disabled="SjError && orderType !== 19" plain type="success"
            @click="goNextPage">
            {{ $t('place.order') }}
          </el-button>
        </div>
        <div style="text-align: left; margin-top: 0.5rem">
          <!-- 放弃新注册首购Btn     17   -->
          <el-button v-show="orderType === 17 && MemberRegisterData" :loading="doLoading" plain type="danger"
            @click="clearMemberRegister">
            {{ $t('AbandonNewlyRegistered') }}
          </el-button>
        </div>
      </div>
      <div v-if="this.shoppingList.length === 0" style="padding: 5px 10px">
        <h4 style="text-align: left;">{{ $t('hint.2') }}</h4>
        <el-button plain style="float: right" type="warning" @click="clickContinue">{{ $t('btn.continue') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getAttendCuxiao, goodsStockAlert, memberNoCanOrder, memberUpOrderCheck, orderPVAlert } from "@/api/rus/api"
import { levelInfoListShow, totalFc2SelectLevelMap, selectLevel2TotalFcMap, levelRules } from "@/utils/constant";

export default {
  name: "Shopping-Cart",
  directives: {},
  components: {},
  data() {
    return {
      levelInfoListShow,
      totalFcSG: '',
      memberLevelType: '',
      levelNumber: 0, // 级别对应的已购pV
      MemberRegisterData: null,
      inputMemberNo2: '',
      inputManager: '',
      inputMemberNo: '',
      sg: 0,
      sj: 0,
      cx: 0,
      chapv: '',
      doLoading: false,
      SjError: false,
      selectlevel: '',
      TotalPrice1: 0,
      TotalPrice2: 0,
      TotalPrice3: 0,
      TotalPrice4: 0,
      TotalPrice5: 0,
      TotalPrice6: 0,
      TotalPrice7: 0,
      orderType: null,
      ContinueColor: false,
      btnBlack: false,
      purchaseInfo: false,
      success: false,
      goodsCode: [],
      ifGoods: false,
    }
  },
  computed: {
    ...mapGetters(["shoppingList", "userCode", 'companyCode']),
  },
  watch: {},
  async created() {
    this.ifSpot()
    this.MemberRegisterData = JSON.parse(sessionStorage.getItem("MemberRegisterData"))
    //  判断是否是登录后注册首购单
    if (this.MemberRegisterData) {
      this.orderType = 17
      this.sg = 1
      this.totalFcSG = sessionStorage.getItem('totalFc')
      this.selectlevel = totalFc2SelectLevelMap[this.totalFcSG]
      this.levelInfoListShow.forEach(item => item.disabled = false)
    } else {
      this.inputMemberNo = this.userCode
      this.getInputMemberNoMessages()
    }

    this.getTotalPrice()
  },
  methods: {
    getHighPrecisionMul(num1, num2) {
      return this.highPrecisionMul(num1, num2) === 0 ? '--' : this.highPrecisionMul(num1, num2)
    },
    // 判断是否现货
    ifSpot() {
      let num = []
      this.goods = this.shoppingList
      for (let index = 0; index < this.shoppingList.length; index++) {
        if (this.shoppingList[index].isSpot == 0) {
          num.push(this.shoppingList[index].goodsCode)
          this.ifGoods = true
          this.goodsCode = String(num);
        }
      }
    },
    getInputMemberNoMessages() {
      this.orderType = null
      if (this.inputMemberNo) {
        this.doLoading = true
        this.memberLevelType = ''
        this.orderType = 0
        memberNoCanOrder({ memberNo: this.inputMemberNo }).then(res => {
          this.doLoading = false
          this.inputMemberNo2 = this.inputMemberNo
          this.inputManager = res.data?.manager
          this.sg = res.data.sg
          this.sj = res.data.sj
          this.cx = res.data.cx
          this.selectlevel = ''
          this.memberLevelType = res.data.levelType
          // 根据levelType设置属性
          if (this.memberLevelType < this.levelInfoListShow[this.levelInfoListShow.length - 1].selectlevel) {
            this.levelNumber = selectLevel2TotalFcMap[this.memberLevelType] || 0
            this.levelInfoListShow.forEach(item => {
              item.disabled = false
              if (item.selectlevel <= this.memberLevelType) {
                item.disabled = true
              }
            })
          } else if (res.data.levelType === 40) {
            this.orderType = 19
          } else {
            // 如果levelType不是预期的任何一个，这里可以添加默认处理或日志记录
            console.warn('Unknown levelType:', res.data.levelType)
          }
        }).catch(err => {
          this.doLoading = false
          this.sg = ''
          this.sj = ''
          this.cx = ''
          this.inputMemberNo2 = ''
          this.inputManager = ''
          console.warn(err)
        })
      } else {
        this.orderType = null
        this.sg = ''
        this.sj = ''
        this.cx = ''
        this.inputMemberNo2 = ''
        this.inputManager = ''
      }
    },
    // 计算总和
    getTotalPrice() {
      this.TotalPrice1 = 0
      this.TotalPrice2 = 0
      this.TotalPrice3 = 0
      this.TotalPrice4 = 0
      this.TotalPrice5 = 0
      this.TotalPrice6 = 0
      this.TotalPrice7 = 0
      for (let i = 0; i < this.shoppingList.length; i++) {
        this.shoppingList[i].proPrice = this.shoppingList[i].proPrice >= 999999 ? 0 : this.shoppingList[i].proPrice
        this.shoppingList[i].standardPv = this.shoppingList[i].standardPv >= 999999 ? 0 : this.shoppingList[i].standardPv
        this.shoppingList[i].proPv = this.shoppingList[i].proPv >= 999999 ? 0 : this.shoppingList[i].proPv
        this.shoppingList[i].proF000 = this.shoppingList[i].proF000 >= 999999 ? 0 : this.shoppingList[i].proF000
        this.shoppingList[i].standardPrice = this.shoppingList[i].standardPrice >= 999999 ? 0 : this.shoppingList[i].standardPrice

        this.TotalPrice1 = this.highPrecisionAdd(this.TotalPrice1, this.highPrecisionMul(this.shoppingList[i].proPrice, this.shoppingList[i].quantity))
        this.TotalPrice2 = this.highPrecisionAdd(this.TotalPrice2, this.highPrecisionMul(this.shoppingList[i].standardPv, this.shoppingList[i].quantity))
        this.TotalPrice3 = this.highPrecisionAdd(this.TotalPrice3, this.highPrecisionMul(this.shoppingList[i].proPv, this.shoppingList[i].quantity))
        this.TotalPrice4 = this.highPrecisionAdd(this.TotalPrice4, this.highPrecisionMul(this.shoppingList[i].proF000, this.shoppingList[i].quantity))
        this.TotalPrice5 = this.highPrecisionAdd(this.TotalPrice5, this.highPrecisionMul(this.shoppingList[i].standardPrice, this.shoppingList[i].quantity))
        this.TotalPrice6 = this.highPrecisionAdd(this.TotalPrice6, this.highPrecisionMul(this.shoppingList[i].proPriceB, this.shoppingList[i].quantity))
        this.TotalPrice7 = this.highPrecisionAdd(this.TotalPrice7, this.highPrecisionMul(this.shoppingList[i].standardPriceB, this.shoppingList[i].quantity))
      }
      this.$store.dispatch('shopping/replaceShoppings', this.shoppingList)
    },
    clickDelete(goodsCode) {
      if (this.goodsCode != '') {
        const arr = this.goodsCode.split(',');
        let index = arr.indexOf(goodsCode);
        if (index != -1) {
          arr.splice(index, 1)
        }
        this.goodsCode = String(arr);
      }
      if (this.goodsCode == '') {
        this.ifGoods = false
      }

      this.$store.dispatch('shopping/deleteSomeone', goodsCode)
      this.getTotalPrice()
    },
    // 关闭信息
    clickPBlack() {
      this.purchaseInfo = false;
    },
    // 继续购买
    clickContinue() {
      this.$router.push({ path: '/' })
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      if (this.orderType === 19) {
        if (row.chongxiao == 1) {
          return 'error-row'
        }
      } else if (this.orderType === 18) {
        if (row.shengji == 1) {
          return 'error-row'
        }
      } else {
        if (row.shougou == 1) {
          return 'error-row'
        }
      }
      return ''
    },
    setOrderType(val) {
      if (val === 19) {
        this.purchaseInfo = !!this.shoppingList.some(ele => ele.chongxiao === 1)
      } else if (val === 18) {
        this.purchaseInfo = !!this.shoppingList.some(ele => ele.shengji === 1)
      } else {
        this.purchaseInfo = !!this.shoppingList.some(ele => ele.shougou === 1)
      }
      sessionStorage.setItem("orderType", JSON.stringify(val))
    },
    setSjLevel(val) {
      // v-if="!MemberRegisterData && orderType !== 19"
      // v-if="totalFcSG && orderType !== 19" 
      if (this.totalFcSG && this.orderType !== 19) {
        return
      }
      this.doLoading = false
      sessionStorage.setItem("selectlevel", JSON.stringify(val))
      if (!this.sg) {
        memberUpOrderCheck({ memberNo: this.inputMemberNo, selectlevel: val }).then(res => {
          this.doLoading = false
          this.SjError = false
          this.chapv = res.data.chapv
        }).catch(err => {
          this.doLoading = false
          this.SjError = true
          console.warn(err)
        })
      }
      console.log(this.levelNumber, this.TotalPrice2, '111111');

      const totalAmount = +this.levelNumber + +this.TotalPrice2
      orderPVAlert({ memberNo: this.inputMemberNo, selectlevel: val, totalAmount }).then(res => {
        this.success = res.success
      }).catch(err => {
        this.doLoading = false
        console.warn(err)
      })
    },
    async goNextPage() {
      // 先判断是否选择订单类型
      if (!this.orderType) {
        return this.$message.error(this.$t('poOrder.pleaseChoose') + this.$t('pd.orderType') + '!')
      }
      // 17或者18时
      if (this.orderType === 17 || this.orderType === 18) {
        if (this.shoppingList.some(e => e.shengji === 1)) {
          return this.$message.error(this.$t('hint.1').toString())
        }
        if (!this.selectlevel && !this.MemberRegisterData) {
          return this.$message.error(this.$t('register.us.select.cardtype').toString()) // 请选择级别
        }
        if (this.selectlevel === '20' && this.levelNumber + this.TotalPrice2 < this.chapv && !this.MemberRegisterData) {
          return this.$message.error(this.$t('error.lower.than.allowed').toString())
        }
        if (this.selectlevel === '30' && this.levelNumber + this.TotalPrice2 < this.chapv && !this.MemberRegisterData) {
          return this.$message.error(this.$t('error.lower.than.allowed').toString())
        }
        if (this.selectlevel === '40' && this.levelNumber + this.TotalPrice2 < this.chapv && !this.MemberRegisterData) {
          return this.$message.error(this.$t('error.lower.than.allowed').toString())
        }

      }
      // 首购单时,判断是否选择了对应级别
      if (this.orderType === 17) {
        // 非黄金三点判断
        if (this.TotalPrice2 <= 1500 || this.TotalPrice2 >= 2000) {
          for (let idx = 0; idx < levelRules.length; idx++) {
            const item = levelRules[idx];
            if (idx === 0) {
              if (this.TotalPrice2 < item.max) {
                return this.$message.error(`PV ≥ ${item.max} !`)
              }
            }
            if (this.TotalPrice2 >= item.min && this.TotalPrice2 < item.max && this.selectlevel != item.selectlevel) {
              return this.$message.error('所选产品pv与级别不符！')
            }
          }
        }
        // 登录后注册的额外赋值
        if (this.MemberRegisterData) {
          this.MemberRegisterData.poOrderVO.totalFc = selectLevel2TotalFcMap[this.selectlevel] || 0
          sessionStorage.setItem("MemberRegisterData", JSON.stringify(this.MemberRegisterData))
        }
      }
      // 判断升级单 下单条件
      if (this.orderType === 18) {
        // 因为没有50状态, 当首购注册完最低为250 所以 级别不考虑判断20
        // 已购PV + 购买总PV 判断是否满足升级条件

        const pvsum = this.highPrecisionAdd(Number(this.levelNumber), Number(this.TotalPrice2))

        for (let idx = 0; idx < levelRules.length; idx++) {
          const item = levelRules[idx];
          if (pvsum >= item.min && pvsum < item.max && this.selectlevel != item.selectlevel) {
            return this.$message.error('所选产品不满足此级别条件！')
          }
        }

      }
      // orderType19
      if (this.orderType === 19) {
        if (this.shoppingList.some(e => e.chongxiao === 1)) {
          return this.$message.error(this.$t('hint.1').toString())
        }
      }
      try {
        const a = [...this.shoppingList.map(v => v.goodsCode)]
        let res = await goodsStockAlert(a)
        this.$message.info(res.message)
      } catch (e) {
        console.error(e)
      }

      sessionStorage.setItem("orderType", JSON.stringify(this.orderType))
      sessionStorage.setItem('OrderSettlement', JSON.stringify(this.shoppingList))
      sessionStorage.setItem('InputMemberNo', JSON.stringify(this.inputMemberNo))
      //重要:不能省略开始
      sessionStorage.setItem('PromotionData', JSON.stringify([]))
      //重要:不能省略结束
      let { data } = await getAttendCuxiao({
        orderType: this.orderType,
        memberNo: this.inputMemberNo,
        goodsList: this.shoppingList,
        selectlevel: this.selectlevel
      })
      if (data.length) {
        console.log(data, 'data')
        sessionStorage.setItem('PromotionData', JSON.stringify(data))
        await this.$router.push({ path: '/promotion-options' })
      } else {
        if (this.MemberRegisterData && this.orderType === 17) {
          await this.$router.push({ path: '/member-register/member-register-settle' })
        } else {
          await this.$router.push({ path: '/order-settle' })
        }
      }


    },
    // // 下单 判断库存r
    // async goNextPage() {

    //   if (!this.orderType) {
    //     return this.$message.error(this.$t('poOrder.pleaseChoose') + ' ' + this.$t('pd.orderType') + '!')
    //   }

    //   if (this.orderType !== 19) {
    //     if (!this.selectlevel) {
    //       return this.$message.error(this.$t('register.us.select.cardtype'))
    //     }
    //   }

    //   // 判断首购单
    //   if (this.orderType === 17) {
    //     // 黄金三点判断 待定: 
    //     // pv >= 1500 且 pv < 2000 必须选择黄金三点 
    //     // pv >= 2000 可以选择黄金三点或者单点


    //     // 非黄金三点判断
    //     if (this.TotalPrice2 <= 1500 || this.TotalPrice2 >= 2000) {
    //       for (let idx = 0; idx < levelRules.length; idx++) {
    //         const item = levelRules[idx];
    //         if (idx === 0) {
    //           if (this.TotalPrice2 < item.max) {
    //             return this.$message.error(`PV ≥ ${item.max} !`)
    //           }
    //         }
    //         if (this.TotalPrice2 >= item.min && this.TotalPrice2 < item.max && this.selectlevel != item.selectlevel) {
    //           return this.$message.error('所选产品pv与级别不符！')
    //         }
    //       }
    //     }


    //   }
    //   // 判断升级单 下单条件
    //   if (this.orderType === 18) {
    //     // 已购PV + 购买总PV
    //     const pvsum = this.highPrecisionAdd(Number(this.levelNumber), Number(this.TotalPrice2))

    //     for (let idx = 0; idx < levelRules.length; idx++) {
    //       const item = levelRules[idx];
    //       if (pvsum >= item.min && pvsum < item.max && this.selectlevel != item.selectlevel) {
    //         return this.$message.error('所选产品不满足此级别条件！')
    //       }
    //     }
    //   }

    //   try {
    //     const a = [...this.shoppingList.map(v => v.goodsCode)]
    //     let res = await goodsStockAlert(a)
    //     this.$message.info(res.message)
    //   } catch (e) {
    //     console.error(e)
    //   }
    //   this.goOrderSettlePage()
    // },
    // goOrderSettlePage() {
    //   sessionStorage.setItem("orderType", JSON.stringify(this.orderType))
    //   sessionStorage.setItem('OrderSettlement', JSON.stringify(this.shoppingList))
    //   sessionStorage.setItem('InputMemberNo', JSON.stringify(this.inputMemberNo))
    //   if (this.orderType === 19) { // orderType19
    //     if (this.shoppingList.some(e => e.chongxiao === 1)) {
    //       return this.$message.error(this.$t('hint.1').toString())
    //     }
    //     this.$router.push({ path: '/order-settle' })  // 19的最终走向
    //   } else { // 17或者18时
    //     if (!this.selectlevel && !this.MemberRegisterData) {
    //       return this.$message.error(this.$t('register.us.select.cardtype').toString()) // 请选择级别
    //     }
    //     if (this.levelNumber + this.TotalPrice2 < this.chapv && !this.MemberRegisterData) {
    //       return this.$message.error(this.$t('error.lower.than.allowed').toString())
    //     }
    //     if (this.orderType === 18) {
    //       if (this.shoppingList.some(e => e.shengji === 1)) {
    //         this.$message.error(this.$t('hint.1').toString());
    //         return
    //       }
    //       this.$router.push({ path: '/order-settle' });
    //     } else if (this.orderType === 17) {
    //       if (this.shoppingList.some(e => e.shougou === 1)) {
    //         this.$message.error(this.$t('hint.1').toString())
    //         return
    //       }
    //       if (!this.MemberRegisterData) {
    //         this.$router.push({ path: '/order-settle' });
    //         return
    //       }
    //       this.MemberRegisterData.poOrderVO.totalFc = selectLevel2TotalFcMap[this.selectlevel] || 0
    //       sessionStorage.setItem("MemberRegisterData", JSON.stringify(this.MemberRegisterData));
    //       this.$router.push({ path: '/member-register/member-register-settle' });
    //     }
    //   }
    // },
    clearMemberRegister() {
      sessionStorage.removeItem('totalFc')
      sessionStorage.removeItem('MemberRegisterData')
      sessionStorage.setItem("orderType", JSON.stringify(18))
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-info {
  text-align: left;
  color: #E6A23C;
  background-color: #FDF6EC;
  margin: 0;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid transparent;
  border-radius: 4px;
}

.p-black {
  color: black;
}

.horizontal-line {
  font-size: 14px;
  color: #a0a0a0;
  text-decoration: line-through;
  padding-left: 12px;
}

::v-deep .el-table.el-table-border {
  .el-table__cell {
    border-right: 1px solid #dddddd;
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
    padding: 0;
  }

  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.TotalPrice-Table {
  border: 1px solid #dddddd;
  margin: 10px 0;
  text-align: left;
}

.btn-continue {
  color: #ffffff;
  text-shadow: 0 0 0 rgb(255 255 255 / 50%);
  background-color: #e7e7e7;
  background-image: linear-gradient(to bottom, #ff5f00, #ff5f00);
  background-repeat: repeat-x;
}

.btn-color-green {
  background: #08a652;
}

.GoodsList ::v-deep .error-row {
  background: rgb(253, 226, 226) !important;
}

@media screen and (max-width: 991px) {
  .AppStyle {
    width: 100% !important;
  }

  .GoodsList {
    font-size: 12px;
  }

  .TotalPrice-Table {
    font-size: 10px;
    transform: scale(1);
  }
}
</style>
